import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Sophia Johnson",
        title: "CEO & Founder",
        biography:
            "Sophia Johnson is the visionary CEO and Founder of our AI-driven SaaS platform. With over a decade of experience in AI and machine learning, Sophia has led the company to success by focusing on innovative solutions and driving industry-leading products. Her dedication to advancing AI technology ensures our platform consistently empowers businesses to achieve greater efficiency and productivity.",
        contacts: {
            phone: "555-987-6543",
            email: "sophia.johnson@example.com",
            website: "www.sophiajohnsonai.com",
        },
        accounts: {
            facebook: "#",
            linkedin: "#",
            twitter: "#",
            instagram: "#",
        },
        experience: [
            "AI Strategy Development",
            "SaaS Platform Leadership",
            "Product Innovation",
            "Client Growth & Success",
            "Industry Thought Leadership",
        ],
        skills: [
            { id: 1, title: "AI Strategy", progress: 98 },
            { id: 2, title: "SaaS Leadership", progress: 95 },
            { id: 3, title: "Product Innovation", progress: 90 },
        ],
    },
    {
        id: 2,
        image: images.team2,
        name: "Liam Smith",
        title: "CTO",
        biography:
            "Liam Smith is the innovative CTO driving the technological vision of our AI-powered SaaS solutions. With extensive experience in cloud infrastructure, AI systems architecture, and scalable product development, he ensures our platform stays at the forefront of technological advancement. His leadership fosters a culture of continuous innovation and technical excellence.",
        contacts: {
            phone: "555-123-7890",
            email: "liam.smith@example.com",
            website: "www.liamsmithtech.com",
        },
        accounts: {
            facebook: "#",
            linkedin: "#",
            twitter: "#",
            instagram: "#",
        },
        experience: [
            "Architected scalable AI platforms",
            "Led cross-functional engineering teams",
            "Implemented cloud-native solutions",
            "Developed secure and resilient SaaS infrastructures",
            "Passionate about tech innovation and leadership",
        ],
        skills: [
            { id: 1, title: "Cloud Architecture", progress: 96 },
            { id: 2, title: "AI Systems", progress: 93 },
            { id: 3, title: "Product Development", progress: 92 },
        ],
    },
    {
        id: 3,
        image: images.team3,
        name: "Olivia Williams",
        title: "Product Manager",
        biography:
            "Olivia Williams is a dynamic Product Manager known for her strategic mindset and passion for delivering customer-focused solutions. With a background in product lifecycle management and agile methodologies, she drives product innovation and ensures seamless collaboration between development, design, and marketing teams.",
        contacts: {
            phone: "555-654-3210",
            email: "olivia.williams@example.com",
            website: "www.oliviawilliamspm.com",
        },
        accounts: {
            facebook: "#",
            linkedin: "#",
            twitter: "#",
            instagram: "#",
        },
        experience: [
            "Led cross-functional teams to deliver AI-driven products",
            "Defined product roadmaps aligned with business goals",
            "Managed full product lifecycle from ideation to launch",
            "Enhanced customer engagement through feature optimization",
            "Advocate for user-centered design and agile practices",
        ],
        skills: [
            { id: 1, title: "Product Management", progress: 95 },
            { id: 2, title: "Agile Methodologies", progress: 92 },
            { id: 3, title: "Team Leadership", progress: 90 },
        ],
    },
    {
        id: 4,
        image: images.team4,
        name: "Ethan Davis",
        title: "Marketing Director",
        biography:
            "Ethan Davis is a results-driven Marketing Director with expertise in digital marketing strategies, brand positioning, and lead generation. With a passion for storytelling and market analysis, Ethan has successfully built brand awareness and driven growth for AI and SaaS companies through data-driven marketing campaigns.",
        contacts: {
            phone: "555-432-1098",
            email: "ethan.davis@example.com",
            website: "www.ethandavismarketing.com",
        },
        accounts: {
            facebook: "#",
            linkedin: "#",
            twitter: "#",
            instagram: "#",
        },
        experience: [
            "Developed and executed comprehensive marketing strategies",
            "Increased brand visibility through digital campaigns",
            "Managed cross-platform social media marketing",
            "Built data-driven lead generation funnels",
            "Focused on customer engagement and brand loyalty",
        ],
        skills: [
            { id: 1, title: "Digital Marketing", progress: 94 },
            { id: 2, title: "Brand Strategy", progress: 91 },
            { id: 3, title: "Lead Generation", progress: 89 },
        ],
    }

];

export default team;